<template>
  <div class="my-menu" v-if="types.length">
    <div
      class="my-menu__tab"
      v-for="(item, index) in types"
      :class="{ 'my-menu__tab--active': typeName === item.name }"
      :key="index"
      @click="handlerChangeTab(item.name)"
    >
      {{item.name}}
      <div class="my-menu__border" v-if="typeName === item.name"></div>
    </div>
  </div>
</template>

<script>
import { ref } from '@vue/composition-api';
import { getCourseTypes } from '@/api/list';

export default {
  props: {
    typeName: {
      type: String,
      default: '全部课程'
    }
  },
  setup(props, { emit }) {
    const types = ref([]);

    getCourseTypes().then((res) => {
      if (res.success && res.data) {
        types.value = res.data;
      }
    });

    const handlerChangeTab = (name) => {
      emit('update:typeName', name);
    };

    return {
      types,
      handlerChangeTab
    };
  },
};
</script>

<style lang="stylus" scoped>
.my-menu__tab {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 54px;
  font-size: 14px;
  color: #666;
}

.my-menu__tab--active {
  font-weight: 500;
  color: #FF9645;
  background: #fff;
}

.my-menu__border {
  position: absolute;
  top: 18px;
  left: 0;
  width: 3px;
  height: 18px;
  background: #FF9645;
}
</style>
